import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

export enum TASK_STATUS_OPTIONS {
  IDLE = 0,
  RUNNING = 1,
  // eslint-disable-next-line no-magic-numbers
  TIMEOUT = 2,
  // eslint-disable-next-line no-magic-numbers
  SUCCESS = 3,
  // eslint-disable-next-line no-magic-numbers
  FAIL = 4
}

export const ERROR_MESSAGE = {
  4830002: '授权文件已失效',
  4830003: '当前云特征库已更新到最新',
  4830004: '部署未到24小时，无需更新特征库',
  4830005: '该离线特征库重复更新',
  4830008: '有任务正在执行，请稍后再试',
  4830013: '非法文件名',
  4830014: "文件名不正确，必须以 'virdb' 开头",
  4830015: '病毒库格式不正确，必须是.zip 格式',
}

export interface ResponseAuthorization {
  /** 授权文件最后生成时间 */
  authorization_last_time: number
  /** 样本库最后更新时间 */
  update_sample_last_time: number

  download_url: string
  /** 打开公共网页的token */
  token: string
}

@Injectable()
export class CloudFeatureOfflineLibraryService {
  constructor (private http: Http) {
  }

  getAuthorization () {
    return this.http.post<ResponseAuthorization>('/sample/get/authorization', {})
  }

  createAuthorization () {
    return this.http.post('/sample/create/authorization', {})
  }

  downloadAuthorizationFile () {
    return this.http.downloadWithBlob('/sample/authorization/download', {}, '云特征离线库授权文件')
  }

  updateUpload (data: any, uploadProgressFunction: (progress: any) => void) {
    return this.http.postForm('/sample/update/upload', data, uploadProgressFunction)
  }
  offLineUpdateUpload (data: any, uploadProgressFunction: (progress: any) => void) {
    return this.http.postForm('/sample/update/offline_virus_database', data, uploadProgressFunction)
  }
}
